import apiService from '../services/ApiService';
import { apiRoutes } from '../shared/apiRoutes';

export interface ClearNotificationsResponse {
  success: boolean;
  message: string;
  deletedCount: number;
}

export interface MarkAllNotificationsReadResponse {
  success?: boolean;
  message?: string;
}

export async function clearAllNotifications(
  tenantId?: number,
): Promise<ClearNotificationsResponse> {
  const result = await apiService.delete<ClearNotificationsResponse>(
    apiRoutes.notifications.clearAll(tenantId),
  );
  return result as ClearNotificationsResponse;
}

export async function deleteNotification(id: number): Promise<void> {
  await apiService.delete(apiRoutes.notifications.deleteOne(id));
}

export async function markAllNotificationsRead(): Promise<MarkAllNotificationsReadResponse> {
  const result = await apiService.patch<MarkAllNotificationsReadResponse>(
    apiRoutes.notifications.markAllRead,
    {},
  );
  return result as MarkAllNotificationsReadResponse;
}
